<div class="container-fluid">
  <p-toast [style]="{marginTop: '80px'}"></p-toast>
  @if (formLoading) {
    <div class="progress-spinner">
      <app-spinner [formLoading]="formLoading"></app-spinner>
    </div>
  }

  <h2>Year Summary Dashboard</h2>

  <br><br>
  @if (showSearchUI) {
    <app-search-template searchLabel="Search" [showSearchButton]=false [showSearchButtonForm2]="true" [reset]=false [reset2]=false [showLocations]=false [showDevelopments]=false
      [showShortTermRentals]=false [showRateBuckets]=false [showBedrooms]=false [showSeasons]=false
      [showReservationStatuses]=false [showStartDate]=false [showEndDate]=false [showSaleDateStart]=false
      [showSaleDateEnd]=false [defaultStartDate]="defaultStartDate" [showSaleYear]=true [displayRecordsOnPageLoad]="false"
      [defaultEndDate]="defaultEndDate" [defaultShortTermRentalIds]="defaultShortTermRentalIds"
      [defaultReservationStatuses]="defaultReservationStatuses" (doSearchCBForm2)="onSearchSubmitYearForm($event)">
    </app-search-template>
  }

  <br>
    <app-development-details [resRevByDay]="resRevByDayForDetailsSearch"></app-development-details>
    <app-location-details [resRevByDay]="resRevByDayForDetailsSearch"></app-location-details>
    <app-channel-details [resRevByDay]="resRevByDayForDetailsSearch"></app-channel-details>
    <app-agent-details [resRevByDay]="resRevByDayForDetailsSearch"></app-agent-details>
    <br><br>
  </div>